import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { get, post, put } from '../../controllers/apiController';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import sozlesmeBg from '../../assets/images/sozlesme-bg.png';

const LEVELUP_INFO = {
    unvan: 'LEVELUP BİLİŞİM DİJİTAL PAZARLAMA VE DIŞ TİC. LTD. ŞTİ.',
    adres: 'Sayar Plaza, İçerenköy Mah. Çayır Cad. No: 11 Kat: 1 Ataşehir İstanbul',
    telefon: '0216 606 20 80',
    eposta: 'info@levelup.email'
};

const buildContractHTML = (data) => {
    const {
        musteriUnvan, musteriAdres, musteriTelefon, musteriEposta,
        baslangicTarihi, sozlesmeKonusu, hizmetler, ucretler
    } = data;

    const tarihStr = baslangicTarihi
        ? new Date(baslangicTarihi).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })
        : '____.____.________';

    const musteriKisaAd = musteriUnvan ? musteriUnvan.split(' ').slice(0, 3).join(' ') : 'MÜŞTERİ';

    const hizmetlerHTML = hizmetler.map((h, i) => `
        <p style="margin: 5px 0;"><span style="font-weight: 600;">3.${i + 1}-</span> ${h}</p>
    `).join('');

    return `
<div style="font-family: 'Montserrat', Arial, sans-serif; font-size: 11.5px; line-height: 1.75; color: #1a1a1a;">

<style>@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap'); * { font-family: 'Montserrat', Arial, sans-serif; }</style>

<h1 style="text-align:center; font-size: 15px; font-weight: 700; letter-spacing: 3px; margin-bottom: 28px; margin-top: 0; text-transform: uppercase; color: #111;">HİZMET SÖZLEŞMESİ</h1>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">1- TARAFLAR</h2>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Unvanı:</span> ${LEVELUP_INFO.unvan} (Bundan sonra LEVELUP olarak anılacaktır)</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Adres:</span> ${LEVELUP_INFO.adres}</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Telefon:</span> ${LEVELUP_INFO.telefon}</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">E-posta:</span> ${LEVELUP_INFO.eposta}</p>
<br/>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Unvanı:</span> ${musteriUnvan || '________________________________'} (Bundan sonra MÜŞTERİ olarak anılacaktır)</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Adres:</span> ${musteriAdres || '________________________________'}</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">Telefon:</span> ${musteriTelefon || '________________________________'}</p>
<p style="margin: 4px 0;"><span style="font-weight: 600;">E-posta:</span> ${musteriEposta || '________________________________'}</p>
<br/>
<p style="margin: 6px 0;">Bu Hizmet Sözleşmesi (bundan sonra "Sözleşme" olarak anılacaktır) yukarıda bilgileri yer almakta olan LEVELUP ile ${musteriKisaAd} arasında aşağıdaki hüküm ve şartlar dâhilinde imzalanmıştır. Bu Sözleşme'de LEVELUP ile ${musteriKisaAd} tek tek "Taraf", birlikte "Taraflar" olarak anılacaktır.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">2- SÖZLEŞME KONUSU</h2>
<p style="margin: 6px 0;">İşbu SÖZLEŞME'nin konusu, aşağıdaki hükümler çerçevesinde verilen; ${sozlesmeKonusu || "MÜŞTERİ'nin talep ettiği hizmetlerin yapılması"} olup bundan böyle "HİZMET / HİZMETLER" olarak anılacaktır.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">3- HİZMETLER</h2>
${hizmetler.length > 0 ? hizmetlerHTML : '<p style="margin: 5px 0;">3.1- [Hizmet açıklaması buraya yazılacaktır.]</p>'}
<p style="margin: 5px 0;"><span style="font-weight: 600;">3.${hizmetler.length + 1}-</span> Sözleşme ${musteriKisaAd} markası için geçerlidir. Hizmet alan firmanın farklı markaları farklı birer proje kapsamında değerlendirilir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">3.${hizmetler.length + 2}-</span> ${musteriKisaAd} tarafından sözleşme kapsamında talep edilen tüm işlerde hafta içi 09.00 – 18.00 saatleri arasında talebin ulaştığının bilgisi yapılacak ve LEVELUP tarafından belirtilen makul bir süre (en fazla 3 iş günü) içerisinde sorun çözülecek veya çalışma yapılacaktır.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">4- ONAY VE YETKİ</h2>
<p style="margin: 5px 0;"><span style="font-weight: 600;">4.1-</span> İşbu Sözleşme kapsamında bulunan hiçbir hizmet, hizmetler ve işler MÜŞTERİ'nin yazılı onayı olmadan başlatılamaz. Onay, elektronik posta haberleşmesi, kısa mesajlaşma ya da toplantı notu biçiminde yazılı olarak teyit edilmiş olmalıdır.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">4.2-</span> Hangi işlerde kimin onay vermeye yetkili olduğu MÜŞTERİ tarafından bu Sözleşme'nin imzalanmasıyla birlikte LEVELUP'a yazılı olarak bildirilir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">4.3-</span> LEVELUP, MÜŞTERİ'nin yazılı onayını almadan MÜŞTERİ'ye maliyet veya yükümlülük getirecek hiçbir alan veya konuda üçüncü şahıslara iş, talimat, sipariş vermeyecek, vaatte bulunmayacaktır.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">4.4-</span> LEVELUP, Sözleşmeye konu hizmetleri sunarken ve işleri yaparken MÜŞTERİ'nin itibar, menfaat ve haklarını, en üst seviyede özeni göstererek koruyacak şekilde hareket edecektir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">4.5-</span> LEVELUP, verdiği hizmetler doğrultusunda MÜŞTERİ internet sitesinde ve/veya herhangi bir mecrada referans olarak gösterme hakkına sahiptir.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">5- SÖZLEŞMENİN SÜRESİ</h2>
<p style="margin: 5px 0;"><span style="font-weight: 600;">5.1-</span> Bu sözleşme ${tarihStr} tarihinde yürürlüğe girecek ve süresiz olarak yürürlükte kalacaktır. Taraflar hiçbir sebep bildirmeksizin 30 gün önceden haber vermek kaydıyla sözleşmeyi feshedebilir. Olası bir fesih durumunda kazanılmış hakların ve yapılmış çalışmaların iadesi söz konusu değildir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">5.2-</span> Sözleşme şartları, tarafların ortak isteği doğrultusunda karşılıklı yazılı mutabakatları üzerine revize edilebilir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">5.3-</span> Sözleşmenin sona ermesi ile birlikte LEVELUP, mevcut tüm panel giriş bilgilerini MÜŞTERİ'ye teslim etmekle yükümlüdür.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">6- ÜCRETLER VE ÖDEME</h2>
${ucretler ? `<p style="margin: 5px 0;"><span style="font-weight: 600;">6.1-</span> ${ucretler}</p>` : '<p style="margin: 5px 0;"><span style="font-weight: 600;">6.1-</span> [Ücret ve ödeme bilgileri buraya yazılacaktır.]</p>'}
<p style="margin: 5px 0;"><span style="font-weight: 600;">6.2-</span> İşbu Sözleşme'de bulunan hizmet bedelleri, sözleşme tarihinden itibaren 1 (bir) yıl sürenin tamamlanmasından sonra TÜİK tarafından belirlenen TEFE/TÜFE oranına göre güncellenecektir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">6.3-</span> İşbu sözleşme kapsamında bulunan tüm faturaların vadesi 7 (yedi) takvim günüdür.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">6.4-</span> Teklifte ve sözleşmede bulunmayan çalışmalar için hizmet bedeli adam/saat ücreti 750 TL'dir ve her yıl TEFE/TÜFE oranında güncellenir.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">7- GİZLİLİK</h2>
<p style="margin: 6px 0;">Taraflar, işbu Sözleşme kapsamında kendilerine diğer Tarafça açıklanan bilgileri büyük bir gizlilik içinde korumayı, herhangi bir üçüncü kişiyle hangi surette olursa olsun paylaşmamayı ve alenileştirmemeyi kabul ve taahhüt ederler. Bu gizlilik yükümlülüğü Sözleşmenin sona ermesinden sonra da süresiz olarak devam eder.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">8- MÜCBİR SEBEP</h2>
<p style="margin: 5px 0;"><span style="font-weight: 600;">8.1-</span> Tarafların kontrolleri dışında gelişen, sözleşme yükümlülüklerinin yerine getirilmesini imkânsızlaştıran haller (tabii afet, savaş, terör, yasal mevzuat değişiklikleri, grev vb.) mücbir sebep olarak kabul edilecektir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">8.2-</span> Mücbir sebep hali 30 (otuz) gün süreyle devam ederse, Taraflardan her birinin sözleşmeyi tek taraflı feshetme hakkı doğacaktır.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">9- TEBLİGAT</h2>
<p style="margin: 6px 0;">İşbu Sözleşme ile ilgili tüm bildirimler yazılı şekilde yapılır. Taraflar sözleşmenin giriş kısmındaki adreslerini tebligat adresi olarak kabul etmişlerdir.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">10- DELİL SÖZLEŞMESİ</h2>
<p style="margin: 6px 0;">İşbu sözleşmenin uygulamasında doğabilecek uyuşmazlıkların hallinde tarafların defter, kayıtları, bilgisayar kayıtları ve her türlü elektronik kayıtlar HMK'nın 193. maddesi uyarınca kesin delil niteliğindedir.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">11- İHTİLAFLARIN HALLİ</h2>
<p style="margin: 6px 0;">İşbu sözleşmenin yorumu ve uygulanmasından doğacak her türlü ihtilafın hallinde İstanbul (Çağlayan) Mahkemesi ve İcra Müdürlüğü yetkili olacaktır.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">12- DEVİR</h2>
<p style="margin: 6px 0;">LEVELUP, işbu Sözleşmede öngörülen yükümlülüklerin tümünü bizzat yerine getirecek olup MÜŞTERİ'nin önceden yazılı izni olmadan sözleşmeden doğan yükümlülük, görev ve haklarını kısmen veya tamamen bir başka kişi, kuruluş veya kuruma devredemez.</p>

<h2 style="font-size: 12px; font-weight: 700; margin-top: 22px; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; color: #111;">13- DİĞER HÜKÜMLER</h2>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.1-</span> İşbu sözleşme maddelerinden herhangi biri geçersiz sayılır ya da iptal edilirse, bu hal sözleşmenin diğer maddelerinin geçerliliğine etki etmez.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.2-</span> İşbu sözleşmeden doğan damga vergisi taraflar arasında yarı yarıya paylaşılacaktır.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.3-</span> Bu sözleşme taraflarca daha önce aynı konuda yapılmış olabilecek yazılı ve sözlü tüm sözleşmelerin yerine geçer.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.4-</span> Sözleşmede yer alan hizmet ve sorumlulukların ihlal veya ihmalinden doğacak tüm zararı, zararı oluşturan taraf ödemekle yükümlüdür.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.5-</span> Tarafların müşterek rıza ve onaylarına dayalı işbu sözleşme 13 (onüç) maddeden ibaret olup ${tarihStr} tarihinde 2 (iki) nüsha olarak tanzim ve imza edilmiştir.</p>
<p style="margin: 5px 0;"><span style="font-weight: 600;">13.6-</span> Ekler: İmza sirküleri.</p>

<div style="display: flex; justify-content: space-between; margin-top: 55px;">
    <div style="text-align: center; width: 45%;">
        <p style="font-weight: 600; margin: 0;">${musteriUnvan || '________________________________'}</p>
        <div style="height: 60px;"></div>
        <p style="margin: 0; border-top: 1px solid #555; padding-top: 6px; font-size: 11px; font-weight: 500;">İmza / Kaşe</p>
    </div>
    <div style="text-align: center; width: 45%;">
        <p style="font-weight: 600; margin: 0;">${LEVELUP_INFO.unvan}</p>
        <div style="height: 60px;"></div>
        <p style="margin: 0; border-top: 1px solid #555; padding-top: 6px; font-size: 11px; font-weight: 500;">İmza / Kaşe</p>
    </div>
</div>

</div>
    `.trim();
};

const Sozlesme = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const formID = searchParams.get('id');
    const contractID = searchParams.get('contractId');

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [formData, setFormData] = useState(null);

    // Form alanları
    const [musteriUnvan, setMusteriUnvan] = useState('');
    const [musteriAdres, setMusteriAdres] = useState('');
    const [musteriTelefon, setMusteriTelefon] = useState('');
    const [musteriEposta, setMusteriEposta] = useState('');
    const [baslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().split('T')[0]);
    const [sozlesmeKonusu, setSozlesmeKonusu] = useState('');
    const [hizmetler, setHizmetler] = useState(['']);
    const [ucretler, setUcretler] = useState('');
    const [baslik, setBaslik] = useState('Hizmet Sözleşmesi');

    // CKEditor içeriği (oluşturulan tam sözleşme)
    const [editorContent, setEditorContent] = useState('');
    const [showEditor, setShowEditor] = useState(false);
    const [existingContractId, setExistingContractId] = useState(null);

    useEffect(() => {
        document.title = 'Sözleşme Oluştur | LEVELUP CRM';

        const loadData = async () => {
            try {
                if (formID) {
                    const res = await get(`forms/${formID}`);
                    setFormData(res);
                    setMusteriUnvan(res.LeadInfo.Firma_Adi || res.LeadInfo.Adi_Soyadi || '');
                    setMusteriTelefon(res.LeadInfo.Telefon || '');
                    setMusteriEposta(res.LeadInfo.E_Posta || '');
                }

                if (contractID) {
                    const contract = await get(`contracts/${contractID}`);
                    setExistingContractId(contract.Sozlesme_ID);
                    setBaslik(contract.Baslik || 'Hizmet Sözleşmesi');
                    setEditorContent(contract.Icerik || '');
                    setShowEditor(true);
                }
            } catch (err) {
                toast.error('Veriler yüklenirken hata oluştu!');
            }
            setIsLoading(false);
        };

        loadData();
    }, [formID, contractID]);

    const addHizmet = () => setHizmetler([...hizmetler, '']);
    const removeHizmet = (index) => setHizmetler(hizmetler.filter((_, i) => i !== index));
    const updateHizmet = (index, value) => {
        const updated = [...hizmetler];
        updated[index] = value;
        setHizmetler(updated);
    };

    const generateContract = () => {
        const html = buildContractHTML({
            musteriUnvan, musteriAdres, musteriTelefon, musteriEposta,
            baslangicTarihi, sozlesmeKonusu,
            hizmetler: hizmetler.filter(h => h.trim()),
            ucretler
        });
        setEditorContent(html);
        setShowEditor(true);
        setTimeout(() => {
            document.getElementById('editor-section')?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    const handleSave = async () => {
        if (!editorContent) {
            toast.error('Sözleşme içeriği boş olamaz!');
            return;
        }

        setIsSaving(true);
        try {
            if (existingContractId) {
                await put(`contracts/${existingContractId}`, {
                    baslik,
                    icerik: editorContent,
                    durum: 'tamamlandi'
                });
                toast.success('Sözleşme güncellendi!');
            } else {
                const res = await post('contracts/', {
                    formId: formID,
                    baslik,
                    icerik: editorContent,
                    durum: 'tamamlandi'
                });
                setExistingContractId(res.Sozlesme_ID);
                toast.success('Sözleşme kaydedildi!');
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Kaydetme sırasında hata oluştu!');
        }
        setIsSaving(false);
    };

    const handlePrint = () => {
        const bgUrl = window.location.origin + sozlesmeBg;
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <title>${baslik}</title>
                <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet">
                <style>
                    @page { margin: 0; size: A4 portrait; }
                    *, *::before, *::after {
                        box-sizing: border-box;
                        font-family: 'Montserrat', Arial, sans-serif;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    html, body { margin: 0; padding: 0; width: 210mm; }
                    .sozlesme-bg {
                        position: fixed;
                        top: 0; left: 0;
                        width: 210mm;
                        height: 297mm;
                        z-index: -1;
                        pointer-events: none;
                    }
                    .sozlesme-bg img {
                        width: 210mm;
                        height: 297mm;
                        display: block;
                    }
                    .sozlesme-content {
                        width: 210mm;
                        padding: 18mm 15mm 55mm 33mm;
                    }
                </style>
            </head>
            <body>
                <div class="sozlesme-bg">
                    <img src="${bgUrl}" alt="">
                </div>
                <div class="sozlesme-content">
                    ${editorContent}
                </div>
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => printWindow.print(), 1000);
    };

    if (isLoading) {
        return (
            <Layout>
                <main className="nxl-container">
                    <div className="nxl-content">
                        <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '70svh' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Yükleniyor...</span>
                            </div>
                        </div>
                    </div>
                </main>
            </Layout>
        );
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./dashboard">Anasayfa</a></li>
                                {formID && <li className="breadcrumb-item"><a href={`./lead-detail?id=${formID}`}>Lead Detay</a></li>}
                                <li className="breadcrumb-item">Sözleşme</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    {showEditor && (
                                        <>
                                            <button onClick={handleSave} disabled={isSaving} className="btn btn-primary">
                                                {isSaving ? (
                                                    <><span className="spinner-border spinner-border-sm me-1"></span>Kaydediliyor...</>
                                                ) : (
                                                    <><i className="feather-save me-1"></i>Kaydet</>
                                                )}
                                            </button>
                                            <button onClick={handlePrint} className="btn btn-success">
                                                <i className="feather-printer me-1"></i>Yazdır / PDF
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row g-3">
                            {/* Sol Panel - Form */}
                            <div className={showEditor ? 'col-md-4' : 'col-md-6 mx-auto'}>
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0">
                                            <i className="feather-edit-3 me-2 text-primary"></i>
                                            Sözleşme Bilgileri
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {/* Başlık */}
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Sözleşme Başlığı</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={baslik}
                                                onChange={(e) => setBaslik(e.target.value)}
                                                placeholder="Hizmet Sözleşmesi"
                                            />
                                        </div>

                                        {/* Müşteri Bilgileri */}
                                        <div className="border rounded p-3 mb-3 bg-light">
                                            <h6 className="fw-bold mb-3 text-primary">
                                                <i className="feather-user me-1"></i>Müşteri Bilgileri
                                            </h6>
                                            <div className="mb-2">
                                                <label className="form-label fw-semibold fs-12">Ünvan / Firma Adı <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={musteriUnvan}
                                                    onChange={(e) => setMusteriUnvan(e.target.value)}
                                                    placeholder="Firma veya kişi adı"
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label fw-semibold fs-12">Adres</label>
                                                <textarea
                                                    className="form-control form-control-sm"
                                                    rows={2}
                                                    value={musteriAdres}
                                                    onChange={(e) => setMusteriAdres(e.target.value)}
                                                    placeholder="Müşteri adresi"
                                                />
                                            </div>
                                            <div className="row g-2">
                                                <div className="col-6">
                                                    <label className="form-label fw-semibold fs-12">Telefon</label>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        value={musteriTelefon}
                                                        onChange={(e) => setMusteriTelefon(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <label className="form-label fw-semibold fs-12">E-posta</label>
                                                    <input
                                                        type="email"
                                                        className="form-control form-control-sm"
                                                        value={musteriEposta}
                                                        onChange={(e) => setMusteriEposta(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Başlangıç Tarihi */}
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Sözleşme Başlangıç Tarihi</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={baslangicTarihi}
                                                onChange={(e) => setBaslangicTarihi(e.target.value)}
                                            />
                                        </div>

                                        {/* Sözleşme Konusu */}
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Sözleşme Konusu (Madde 2)</label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={sozlesmeKonusu}
                                                onChange={(e) => setSozlesmeKonusu(e.target.value)}
                                                placeholder="Ör: MÜŞTERİ'nin dijital reklam yönetimi, sosyal medya yönetimi ve web sitesi tasarımı hizmetlerinin yapılması"
                                            />
                                        </div>

                                        {/* Hizmetler */}
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold d-flex align-items-center justify-content-between">
                                                <span>Hizmetler (Madde 3)</span>
                                                <button className="btn btn-sm btn-light-primary" onClick={addHizmet}>
                                                    <i className="feather-plus me-1"></i>Madde Ekle
                                                </button>
                                            </label>
                                            {hizmetler.map((hizmet, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <span className="fw-semibold text-muted mt-2" style={{ minWidth: '30px' }}>3.{index + 1}</span>
                                                    <textarea
                                                        className="form-control form-control-sm"
                                                        rows={2}
                                                        value={hizmet}
                                                        onChange={(e) => updateHizmet(index, e.target.value)}
                                                        placeholder={`${index + 1}. hizmet açıklaması`}
                                                    />
                                                    {hizmetler.length > 1 && (
                                                        <button className="btn btn-sm btn-light-danger mt-1" onClick={() => removeHizmet(index)}>
                                                            <i className="feather-trash-2"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Ücretler */}
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Ücretler ve Ödeme (Madde 6)</label>
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                value={ucretler}
                                                onChange={(e) => setUcretler(e.target.value)}
                                                placeholder="Ör: Sosyal medya yönetimi için aylık 15.000 TL + KDV, dijital reklam yönetimi için aylık 10.000 TL + KDV olarak ücretlendirilecektir."
                                            />
                                        </div>

                                        <button className="btn btn-primary w-100" onClick={generateContract}>
                                            <i className="feather-eye me-2"></i>
                                            {showEditor ? 'Sözleşmeyi Yenile' : 'Sözleşme Oluştur'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Sağ Panel - CKEditor */}
                            {showEditor && (
                                <div className="col-md-8" id="editor-section">
                                    <div className="card">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="card-title mb-0">
                                                <i className="feather-file-text me-2 text-success"></i>
                                                Sözleşme Önizleme &amp; Düzenleme
                                            </h5>
                                            <span className="badge bg-info text-white fs-11">
                                                Tüm metni buradan düzenleyebilirsiniz
                                            </span>
                                        </div>
                                        <div className="card-body p-0" style={{
                                            backgroundImage: `url(${sozlesmeBg})`,
                                            backgroundSize: '100% auto',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'left top'
                                        }}>
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={editorContent}
                                                config={{
                                                    toolbar: [
                                                        'heading', '|',
                                                        'bold', 'italic', 'underline', '|',
                                                        'bulletedList', 'numberedList', '|',
                                                        'indent', 'outdent', '|',
                                                        'blockQuote', '|',
                                                        'insertTable', '|',
                                                        'undo', 'redo'
                                                    ],
                                                    language: 'tr',
                                                    contentsCss: [
                                                        "@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');",
                                                        "body { font-family: 'Montserrat', Arial, sans-serif; font-size: 11.5px; line-height: 1.75; color: #1a1a1a; padding: 18mm 15mm 55mm 33mm !important; margin: 0; background: transparent; }"
                                                    ]
                                                }}
                                                onChange={(event, editor) => {
                                                    setEditorContent(editor.getData());
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default Sozlesme;
